import React, { FC } from 'react'
import { Layout } from 'antd'
import { useRouteMatch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import { useForumUnread } from '../../components/forum/use-forum-unread'
import { COMPETENCY_TOPIC, FORUM_TOPIC } from '../../constants/routes'
import { Header, Menu } from '../../components/navigation'
import ErrorHandler from '../../components/navigation/error-handler/error-handler'
import Alert from '../../components/common/alert/alert'
import Footer from '../../components/navigation/footer/footer'
import useCheckUserProfile from '../../hooks/useCheckUserProfile'
import useCheckPathForUserProfile from '../../hooks/useCheckPathForUserProfile'
import PasswordExpiredModal from '../../components/password-expired-modal/password-expired-modal'
import GuestChatWidget from '../../components/guest-chat/guest-chat'
import styles from './default-app.module.scss'

const DefaultApp: FC = (props) => {
  const { children } = props
  useCheckUserProfile()
  const competence = useSelector((state: RootState) => state.account.user?.competence?.id)
  useForumUnread(String(competence || 0), true)
  const isUserProfile = useCheckPathForUserProfile()
  const isDiscussion = !!useRouteMatch({ path: [FORUM_TOPIC, COMPETENCY_TOPIC], exact: true })
  return (
    <>
      <Layout>
        <Layout.Header role={'heading'} className={isDiscussion ? styles.discussionHeader : undefined}>
          <Header />
        </Layout.Header>
        <Layout>
          {!isUserProfile && (
            <>
              <Layout.Sider width={292} breakpoint={'xl'} collapsedWidth={0}>
                <Menu />
              </Layout.Sider>
            </>
          )}
          <Layout.Content>
            <ErrorHandler>{children}</ErrorHandler>
          </Layout.Content>
        </Layout>
        <Alert />
        <PasswordExpiredModal />
      </Layout>
      <Layout.Footer>
        <Footer />
      </Layout.Footer>
      <GuestChatWidget />
    </>
  )
}

export default DefaultApp
